import { render } from "./WelcomeCard.vue?vue&type=template&id=fcda057a"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__